import { apiClient, ApiResponse } from "./apiClient";
import { AuthType, LoginAuthType } from "../models/enums";
import { IAppUser } from "../models/IAppUser";
import { logger } from "../Services/LoggingService";

class LoginAPI {
    getForgotPass = async (userEmail: string) => {

        await apiClient("Login/ForgotPassword?userEmail=" + userEmail, undefined, AuthType.Basic)
            .then((ret: ApiResponse) => {
                logger.info("Login/ForgotPassword results", ret);
                if (!hasErrors(ret)) {
                    logger.info("Forgot password request has been processed.");
                }
            })
            .catch((err) => {handleErrors(err)});
    };

    postLogin = async (user: IAppUser) => {
        let response: IAppUser = {
            Id: -1
        };

        await apiClient("Login/Login", { method: "POST", body: JSON.stringify({ Name: user.Name, Email: user.Email, AuthType: LoginAuthType[user.AuthType as number], Password: user.Password}) }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                //logger.info("Login/Login results", ret);
                if (!hasErrors(ret)) {
                    //return response = ret.response;
                    //return response = JSON.parse(JSON.stringify(ret.response));
                    return response = ret.response as unknown as IAppUser;
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    };

    postRegister = async (user: IAppUser) => {
        let response: IAppUser = {
            Id: -1
        };

        await apiClient("Login/Register", { method: "POST", body: JSON.stringify(user) }, AuthType.Basic)
            .then((ret: ApiResponse) => {
                logger.info("Login/Register results", ret);
                if (!hasErrors(ret)) {
                    return response = ret.response as unknown as IAppUser;
                }
            })
            .catch((err) => {handleErrors(err)});

        return response;
    };
};

const handleErrors = (err: any) => {
    if (err) {
        logger.error("" + err);
    } else {
        logger.error("Error from apiClient in LoginAPI");
    }
};

const hasErrors = (ret: ApiResponse) => {
    if ((ret.status !== 200) && (ret.status !== 201) && (ret.status !== 202) && (ret.status !== 204)) {
        handleErrors(ret.response)
        return true;
    }
    return false;
};

export const loginAPI = new LoginAPI();